module.exports = __webpack_public_path__ + "static/media/processing.45eb4fbc.svg";